import { BalanceAIColoredIcon } from 'common/icons';
import { PurpleColors } from 'theme';

interface CropwiseAiButtonProps {
  text?: string | null;
}

const CropwiseAiButton = ({ text }: CropwiseAiButtonProps) => {
  return (
    <>
      <style>
        {`
          .cropwise-ai-button {
            height: 32px;
            border-radius: 32px;
            border: 1px solid ${PurpleColors[60]};
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 0 12px;
            background-color: ${PurpleColors[10]};
            color: ${PurpleColors[60]};
            cursor: pointer;
            transition: background-color 0.2s ease-in-out;
          }
          
          .cropwise-ai-button:hover {
            background-color: ${PurpleColors[20]};
          }
        `}
      </style>
      <button type="button" className="cropwise-ai-button">
        <BalanceAIColoredIcon />
        {text}
      </button>
    </>
  );
};

export { CropwiseAiButton };
